/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';

export default (ChildComponent) => {
    class RequireAdmin extends Component {
        render() {
            if (this.props.auth.user && this.props.auth.user.isAdmin) {
                return <ChildComponent {...this.props} />;
            }
            return <Redirect to={`/home`} />;
        }
    }

    function mapStateToProps({ auth }) {
        return { auth };
    }

    return connect(mapStateToProps)(withRouter(RequireAdmin));
};
